// ThemeToggle — cycles through 'auto' | 'light' | 'dark' theme modes.
// Applies via changeGlobalTheme (never direct data-theme mutation).
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.
// Per DESIGN domain knowledge: never mutate data-theme from project code;
// use changeGlobalTheme(name) from scratch.

const MODES = ['auto', 'light', 'dark']

const _modeIcon = (mode) => {
  if (mode === 'light') return 'sun'
  if (mode === 'dark') return 'moon'
  return 'contrast' // auto
}

const _nextMode = (current) => {
  const idx = MODES.indexOf(current)
  return MODES[(idx + 1) % MODES.length]
}

export const ThemeToggle = {
  extends: 'Button',
  padding: 'Z1',
  round: '50%',
  cursor: 'pointer',
  theme: 'tertiary',
  title: (el, s) => `Theme: ${s.root?.themeMode || 'auto'}`,

  Icon: {
    name: (el, s) => _modeIcon(s.root?.themeMode || 'auto'),
    boxSize: 'A A'
  },

  onClick: (e, el, s) => {
    e.preventDefault()
    const current = s.root?.themeMode || 'auto'
    const next = _nextMode(current)
    // Update state
    if (s.root) s.root.themeMode = next
    // Persist
    localStorage.setItem('themeMode', next)
    // Signal cross-tab — storage event fires in OTHER tabs only; same tab
    // applies via state mutation above.
    localStorage.setItem('themeMode', next)
    // Apply to document via framework-approved path
    el.call('changeGlobalTheme', next)
  }
}
